import { render, staticRenderFns } from "./workshoplist.vue?vue&type=template&id=02ca1e92&scoped=true&"
import script from "./workshoplist.vue?vue&type=script&lang=js&"
export * from "./workshoplist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca1e92",
  null
  
)

export default component.exports